
import { Box, Typography } from "@mui/material";
import React from "react";
import SeverityAlert from "../../images/SeverityAlert.svg";
import Check from "../../images/Checkbox.svg";
import CustomTableHeading from '../CommonComponents/CustomTableHeading';
import CustomTableMetric from '../CommonComponents/CustomTableMetric';
import CustomActionButton from "../CommonComponents/CustomActionButton";
import "../../cssfiles/homepage.css";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomLabel from "../CommonComponents/CustomLabel";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomSelect from "../CommonComponents/CustomSelect";
import CustomMultiSelect from "../CommonComponents/CustomMultiSelect";
import TreeApp from "./TreeApp";

export default function GroupConfiguration() {
    return (
        <div>
            <TreeApp />
        </div>
    )
}